import { Component, OnInit } from '@angular/core';
import { InformacionService } from '../../../services/informacion.service';
@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html'
})
export class FooterComponent implements OnInit {

  constructor(public _is: InformacionService) { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /Users/diego/Documents/SirisWebSite/WebSite/src/app/components/shared/footer/footer.component.ts